import { useEffect, FunctionComponent } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { log } from '~/helpers/bugsnagHelper';
import { memberIdSelector } from '~/App/shared/selectors/sessionSelector';
import { ReduxStore } from '~/App/shared/interfaces/store';

interface RecombeeResponse {
  (error: Error, response: Response): void;
}

interface RecombeeClient {
  send(recombeeClient: RecombeeClient, responseHandle: RecombeeResponse): void;
}

interface ApiClient {
  new (databaseId: string, publicToken: string): RecombeeClient;
}

interface AddDetailView {
  new (memberId: string, auctionId: string): RecombeeClient;
}

interface Recombee {
  ApiClient: ApiClient;
  AddDetailView: AddDetailView;
}

declare global {
  interface Window {
    recombee: Recombee;
    RECOMBEE_DATABASE_ID: string;
    RECOMBEE_PUBLIC_TOKEN: string;
  }
}

interface Props extends StateProps {
  auctionId: string;
}

const Recombee: FunctionComponent<Props> = ({
  memberId,
  auctionId
}: Props): null => {
  useEffect(() => {
    const recombee = window.recombee;
    if (!recombee || !memberId) {
      return;
    }

    const { ApiClient, AddDetailView } = recombee;

    const { RECOMBEE_DATABASE_ID, RECOMBEE_PUBLIC_TOKEN } = window;
    const client: RecombeeClient = new ApiClient(
      RECOMBEE_DATABASE_ID,
      RECOMBEE_PUBLIC_TOKEN
    );

    client.send(
      new AddDetailView(memberId, auctionId),
      (error: Error) =>
        error &&
        log(new Error('Failed AddDetailsView Recombee'), {
          error,
          severity: 'info'
        })
    );
  }, [memberId, auctionId]);

  return null;
};

interface StateProps {
  memberId: string;
}

const mapStateToProps = createStructuredSelector<ReduxStore, StateProps>({
  memberId: memberIdSelector
});

export default connect(mapStateToProps)(Recombee);
